const tools = [
  {
    icon: 'ri-bar-chart-line',
    title: 'Energy & Safety Net Tracker',
    path: 'Path 1',
    desc: 'Build awareness and start tracking your energy daily.',
  },
  {
    icon: 'ri-file-list-3-line',
    title: 'Awareness Worksheet',
    path: 'Path 2',
    desc: 'Identify your energy peaks, dips, and hidden patterns.',
  },
  {
    icon: 'ri-calendar-check-line',
    title: 'Daily Spoon Tracker',
    path: 'Path 3',
    desc: 'Plan your day without overloading your capacity.',
  },
  {
    icon: 'ri-shield-star-line',
    title: 'The Protectometer',
    path: 'Path 4',
    desc: 'Map what drains you (DIMs) and what supports you (SIMs).',
  },
  {
    icon: 'ri-loop-left-line',
    title: 'The Continuity Loop',
    path: 'Path 5',
    desc: 'Stay consistent and keep momentum — even with setbacks.',
  },
];

const audiences = [
  'Chronic Illness — fatigue, pain and unpredictable physical symptoms',
  'ADHD & Autism — sensory overload, focus leakage and emotional drain',
  'Life-Demand Mismatch — when daily responsibilities outpace your energy',
];

export default function ToolsAndAudience() {
  return (
    <section className="relative overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          alt="Soft airy eucalyptus leaves on pale background"
          className="w-full h-full object-cover"
          src="https://readdy.ai/api/search-image?query=Very%20soft%20pale%20white%20and%20light%20gray%20background%20with%20delicate%20airy%20eucalyptus%20leaves%20and%20fern%20branches%2C%20minimalist%20botanical%20composition%2C%20subtle%20watercolor%20style%2C%20gentle%20diffused%20light%2C%20calming%20wellness%20aesthetic%2C%20muted%20sage%20and%20soft%20silver%20tones%2C%20editorial%20photography%2C%20serene%20peaceful%20atmosphere&width=1600&height=900&seq=course-tools-01&orientation=landscape"
        />
        <div className="absolute inset-0 bg-white/75" />
      </div>

      <div className="relative z-10 section-padding max-w-6xl mx-auto">
        {/* Tools */}
        <div className="mb-16">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-primary-800 text-center mb-3">
            Your Tools &amp; Trackers
          </h2>
          <p className="text-sm text-foreground-500 text-center mb-10">
            Each path comes with a simple, practical PDF to help you apply the system in real life.
          </p>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {tools.map((tool) => (
              <div
                key={tool.title}
                className="flex items-start gap-4 bg-[#6B8FA3]/90 backdrop-blur-sm border border-[#5A7F94]/40 rounded-xl p-5 shadow-lg hover:bg-[#6B8FA3] hover:-translate-y-1 hover:shadow-xl transition-all duration-300"
              >
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-white/15 shrink-0">
                  <i className={`${tool.icon} text-lg text-white`} />
                </div>
                <div>
                  <span className="text-xs font-medium text-white/60 uppercase tracking-wider">
                    {tool.path}
                  </span>
                  <h3 className="font-heading text-sm font-semibold text-white mt-0.5 mb-1">
                    {tool.title}
                  </h3>
                  <p className="text-xs text-white/70 leading-relaxed">
                    {tool.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Designed For */}
        <div className="max-w-3xl mx-auto">
          <div className="flex items-center justify-center gap-2 mb-6">
            <span className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-100">
              <i className="ri-user-heart-line text-primary-600" />
            </span>
            <h2 className="font-heading text-xl font-bold text-primary-800">Designed For These Three Groups</h2>
          </div>
          <p className="text-sm text-foreground-600 text-center leading-relaxed max-w-2xl mx-auto mb-6">
            The Energy-Safe Course is built for chronic illness, ADHD/Autism sensory drain, and life-demand mismatch.
            Through energy-safe motions, you learn to break the Boom &amp; Bust cycle and build sustainable,
            guilt-free progress.
          </p>
          <div className="space-y-3">
            {audiences.map((a, i) => (
              <div
                key={i}
                className="flex items-start gap-3 bg-[#6B8FA3]/90 backdrop-blur-sm rounded-lg px-5 py-4 border border-[#5A7F94]/40 shadow-lg"
              >
                <span className="mt-0.5 w-5 h-5 flex items-center justify-center shrink-0">
                  <i className="ri-check-line text-sm text-white/80" />
                </span>
                <p className="text-sm text-white/90">{a}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}